<table class="table table-striped text-align--center width--100">
  @for (pair of weeks | keyvalue; track pair.key) {
    <tr class="border-bottom--1">
      <td>
        <span class=" text--normal background-color--lightest-gray padding-left-right--1x">v.{{getWeekNumber(pair.key)}}</span>
      </td>
      @for (item of pair.value; track $index) {
        <td class="background-color--lightest-gray">
            <label class="margin--none text--normal" [attr.for]="dateFieldId(item)">{{item.date | date:DATE_FORMAT}}</label>
        </td>
      }
    </tr>
    <tr>
      <td>
        <div class="flex__container justify-content--center padding-bottom--2x">
          <input class="checkbox" [disabled]="isWeekForcedDisabled(pair.key)" [checked]="isWeekSelected(pair.key)" (click)="toggleWeek(pair.key)" type="checkbox">
        </div>
      </td>
      @for (item of pair.value; track $index) {
        <td>
          <div class="flex__container justify-content--center padding-bottom--2x">
            <input class="checkbox" [disabled]="item.disabled || item.forceDisabled" [checked]="item.selected" (click)="toggleDay(item);" type="checkbox" [attr.id]="dateFieldId(item)">
          </div>
        </td>
      }
    </tr>
  }
</table>
